import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "react/jsx-runtime";
import {useMDXComponents as _provideComponents} from "next-mdx-import-source-file";
function _createMdxContent(props) {
  const _components = {
    a: "a",
    br: "br",
    h1: "h1",
    h2: "h2",
    li: "li",
    p: "p",
    strong: "strong",
    ul: "ul",
    ..._provideComponents(),
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.h1, {
      children: _jsx(_components.strong, {
        children: "كيف تعمل الفورمولا 1؟"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["الفورمولا 1، أو F1، هي البطولة الأولى لرياضات السيارات في العالم، حيث يتنافس أسرع السيارات وأعظم السائقين في تقويم عالمي من جوائز كبرى (سباقات).", _jsx(_components.br, {}), "\n", "هذه ليست مجرد سباقات. إنها مزيج من السرعة القصوى، التكنولوجيا المتطورة، والمهارات البشرية البحتة، ويشاهدها الملايين حول العالم."]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "السيارات"
      })
    }), "\n", _jsx(_components.p, {
      children: "سيارات الفورمولا 1 هي آلات متطورة تم تصميمها لتحقيق أقصى درجات السرعة والدقة."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "السرعة القصوى"
        }), ": أكثر من 350 كم/س."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "التسارع"
        }), ": من 0 إلى 100 كم/س في أقل من 2 ثانية."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "التكلفة"
        }), ": يمكن أن تتجاوز تكلفة بناء كل سيارة 15 مليون دولار أمريكي."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "الفرق"
      })
    }), "\n", _jsx(_components.p, {
      children: "الفورمولا 1 هي رياضة جماعية، حيث يوجد 10 فرق كل منها يشغل سيارتين. كل فريق يتكون من مصممين، مهندسين، استراتيجيين، ميكانيكيين، وسائقين من الطراز العالمي يعملون معًا للفوز بالسباقات والبطولات."
    }), "\n", _jsx(_components.p, {
      children: "الفرق الشهيرة تشمل:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "مرسيدس-إيه إم جي بتروناس"
      }), "\n", _jsx(_components.li, {
        children: "سكوديريا فيراري"
      }), "\n", _jsx(_components.li, {
        children: "رد بُل ريسينغ"
      }), "\n", _jsx(_components.li, {
        children: "مكلارين"
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "البطولة"
      })
    }), "\n", _jsx(_components.p, {
      children: "كل موسم يتضمن حوالي 24 سباقًا في دول حول العالم، من شوارع موناكو الضيقة إلى صحاري الشرق الأوسط."
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "يحصل السائقون على نقاط بناءً على ترتيبهم في النهاية."
      }), "\n", _jsx(_components.li, {
        children: "في نهاية الموسم، السائق الذي يحصل على أكبر عدد من النقاط يفوز ببطولة السائقين."
      }), "\n", _jsx(_components.li, {
        children: "الفرق تتنافس أيضًا على بطولة الصانعين، وهي معركة من أجل أفضل فريق بشكل عام."
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "عطلة نهاية أسبوع السباق"
      })
    }), "\n", _jsx(_components.p, {
      children: "كل جائزة كبرى (عطلة نهاية الأسبوع) تتبع هذا التنسيق:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "الجمعة"
        }), ": التدريب 1 و 2 - السائقون يختبرون السيارة والحلبة والإطارات."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "السبت"
        }), ": التدريب 3 + التأهل - التأهل هو معركة توقيت للحصول على أفضل موقع للانطلاق في السباق."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "الأحد"
        }), ": يوم السباق - الحدث الرئيسي، سباق كامل من أجل الفوز. أول سيارة تعبر خط النهاية تفوز."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "ما الذي يجعل الفورمولا 1 مثيرة؟"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "السرعة الجنونية"
        }), ": السيارات تأخذ المنعطفات بسرعة لدرجة أن السائقين يشعرون بقوى جي تصل إلى 6 (كأنهم يُقذفون إلى الفضاء)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "الاستراتيجية في الوقت الفعلي"
        }), ": يجب على الفرق إدارة تآكل الإطارات، وحمولة الوقود، وتغيرات الطقس، pit stops، كل قرار يمكن أن يغير مجريات السباق."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "التنافس والدراما"
        }), ": الفورمولا 1 مشهورة بالتنافس الشديد (مثل هاميلتون ضد فيرستابن) واللحظات المثيرة للجدل (الاصطدامات، أوامر الفريق، وأكثر)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "العرض العالمي"
        }), ": الفورمولا 1 ليست مجرد سباق، بل هي سيرك متجول، مع حفلات موسيقية، مهرجانات للجماهير، وحفلات في كل مدينة مضيفة."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "لماذا الفورمولا 1 في السعودية مميزة؟"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "سباقات ليلية"
        }), ": واحدة من السباقات القليلة التي تُقام تحت الأضواء الكاشفة، مما يجعلها مذهلة بصريًا."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "حلبة شارع"
        }), ": السباق عبر شوارع جدة الفعلية، الجدران قريبة، السرعات عالية، والأخطاء مكلفة."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "حلبة ساحلية"
        }), ": السباق الوحيد في الفورمولا 1 الذي يطل على البحر الأحمر."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "أجواء المهرجانات"
        }), ": حفلات موسيقية، طعام، تجارب ثقافية، تجربة شاملة طوال عطلة نهاية الأسبوع."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "الفورمولا 1 بالأرقام"
      })
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "1950"
        }), ": أول موسم للفورمولا 1."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "5G"
        }), ": القوة التي يشعر بها السائقون في المنعطفات."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "2 ثانية"
        }), ": الوقت الذي يستغرقه تغيير الإطارات في pit stop."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "1.88 ثانية"
        }), ": أسرع pit stop على الإطلاق (رد بُل، 2019)."]
      }), "\n", _jsxs(_components.li, {
        children: [_jsx(_components.strong, {
          children: "500 مليون"
        }), ": عدد المشاهدين العالميين لكل موسم."]
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "لماذا يجب أن تشاهده مباشرة؟"
      })
    }), "\n", _jsx(_components.p, {
      children: "التلفزيون مثير، ولكن مشاهدته مباشرة؟ إنها تجربة حواس لا مثيل لها:"
    }), "\n", _jsxs(_components.ul, {
      children: ["\n", _jsx(_components.li, {
        children: "هدير المحركات بأقصى سرعة."
      }), "\n", _jsx(_components.li, {
        children: "رائحة المطاط المحترق."
      }), "\n", _jsx(_components.li, {
        children: "طاقة الحشود، كل تجاوز يبدو وكأنه هدف في مباراة كرة قدم."
      }), "\n", _jsx(_components.li, {
        children: "السرعة، عينيك بالكاد تستطيع اللحاق بها."
      }), "\n"]
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "أول مرة؟ لا مشكلة."
      })
    }), "\n", _jsx(_components.p, {
      children: "نحن هنا للمساعدة، من شرح القواعد إلى مساعدتك في اختيار التذكرة المناسبة (سواء كنت ترغب في الرفاهية أو أجواء الحفلات). الجميع يبدأ من مكان ما، وسباقك الأول سيكون لا يُنسى."
    }), "\n", _jsx("br", {}), "\n", _jsx(_components.h2, {
      children: _jsx(_components.strong, {
        children: "هل أنت مستعد لتجربة الفورمولا 1 بنفسك؟"
      })
    }), "\n", _jsxs(_components.p, {
      children: ["⚡️ ", _jsx(_components.a, {
        href: "#",
        children: "استكشف التذاكر والعروض الآن"
      })]
    })]
  });
}
export default function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = {
    ..._provideComponents(),
    ...props.components
  };
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}
